import { createActionGroup, props } from '@ngrx/store';
import { PixelFrame } from '@models/frame.model';
import { AiGenerateRequest } from '@models/ai-generation.model';

export const AiActions = createActionGroup({
  source: 'AI',
  events: {
    'Generate Frames': props<{ request: AiGenerateRequest }>(),
    'Generate Frames Success': props<{ frames: PixelFrame[] }>(),
    'Generate Frames Failure': props<{ error: string }>(),
    'Set Api Key': props<{ apiKey: string }>(),
    'Clear Error': props<Record<string, never>>(),
  }
});
